import { TextField, TextFieldProps } from "@mui/material";
import React, { useMemo } from "react";
import { IStyleProps } from "../interface";
import classnames from "classnames";
import stl from "../styles/textarea.module.scss";
interface IProps
    extends IStyleProps,
        Omit<TextFieldProps<"outlined">, "variant"> {}
const FmTextArea: React.FC<IProps> = (props) => {
    const { InputProps, ...rest } = props;
    const { classes, inputProps } = useMemo(() => {
        if (InputProps) {
            const { classes = {}, ...inputProps } = InputProps;
            return { classes, inputProps };
        }
        return {
            classes: {},
            inputProps: {},
        };
    }, [InputProps]);

    return (
        <TextField
            classes={{
                root: classnames(stl["text-filed-root"], "text-filed-root"),
                ...props.classes,
            }}
            id="outlined-multiline-flexible"
            multiline
            rows={props.rows}
            variant={"outlined"}
            InputProps={{
                ...inputProps,
                classes: {
                    ...classes,
                    root: classnames(
                        stl["input-label"],
                        "input-label",
                        classes.root,
                    ),
                    input: classnames(
                        "input-show-to",
                        stl["textarea-input"],
                        classes.input,
                    ),
                    focused: classnames(
                        stl["focused-textarea"],
                        classes.focused,
                    ),
                },
            }}
            FormHelperTextProps={{
                classes: {
                    root: classnames(
                        stl["help-text"],
                        "help-text",
                        props.FormHelperTextProps?.classes?.root,
                    ),
                    error: classnames(
                        stl["input-help-text-error"],
                        "input-help-text-error",
                        props.FormHelperTextProps?.classes?.error,
                    ),
                },
            }}
            InputLabelProps={{
                classes: {
                    root: classnames(stl["input-label"], "input-label"),
                    ["outlined"]: classnames("variant-input"),
                    formControl: "form-control-base-input",
                },
            }}
            {...rest}
        />
    );
};

export default FmTextArea;
